var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "user", attrs: { title: _vm.currentUser.userName } },
    [
      _c("i", { staticClass: "fas fa-user d-inline" }),
      _vm._v(" "),
      _c("span", [
        _vm._v(_vm._s(_vm._f("truncate")(_vm.currentUser.userName, _vm.maxLen)))
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }